import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

/** Pill-style single choice control (date ranges, small filters). */
export function Segmented<T extends string | number>({
  value,
  options,
  onChange,
  label,
  size = 'md',
}: {
  value: T;
  options: { value: T; label: ReactNode }[];
  onChange: (v: T) => void;
  label: string;
  size?: 'sm' | 'md';
}) {
  return (
    <div
      role="radiogroup"
      aria-label={label}
      className="inline-flex rounded-xl border border-slate-200/80 bg-slate-100/70 p-1"
    >
      {options.map((o) => {
        const active = o.value === value;
        return (
          <button
            key={String(o.value)}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => onChange(o.value)}
            className={cn(
              'rounded-lg font-medium whitespace-nowrap transition-all',
              size === 'sm' ? 'px-2.5 py-1 text-xs' : 'px-3.5 py-1.5 text-sm',
              active
                ? 'text-brand-700 bg-white shadow-sm ring-1 ring-slate-200/80'
                : 'text-slate-500 hover:text-slate-800',
            )}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
